<template>
  <Head>
    <Title>{{ errorState.title ?? 'Error' }}</Title>
    <Meta name="description" content="Error Page" />
  </Head>

  <Navbar />
  <div
    class="flex justify-center h-navbar-m-screen lg:h-navbar-screen p-6 lg:p-12 items-center inset-0"
  >
    <UiBgGrid class="absolute inset-0" />
    <div class="lg:max-w-xl relative">
      <div class="p-8 lg:p-10 flex flex-col items-center text-center">
        <UiEffect404
          v-if="props.error?.statusCode"
          class="mb-5"
          :text="props.error?.statusCode.toString()"
          :enable-hover="true"
          :base-intensity="0.3"
          :hover-intensity="0.7"
        />
        <h2 class="font-bold text-xl">{{ errorState.title }}</h2>
        <div>{{ errorState.description }}</div>
        <div class="opacity-50 mt-3">
          <span>Build Version: </span>
          <span>{{ config.appVersion ?? 'Unknown Version' }}</span>
        </div>

        <UiButton
          v-if="isOnline"
          label="Kembali"
          icon="material-symbols:arrow-back"
          class="mx-auto mt-4"
          variant="primaryOutline"
          @click="back"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import { useOnline } from '@vueuse/core'

const isOnline = useOnline()
const { public: config } = useRuntimeConfig()

const props = defineProps<{
  error?: NuxtError
}>()

const errorState = computed(() => {
  if (!isOnline.value) {
    return {
      title: 'Koneksi Internet Terputus',
      description:
        'Silahkan periksa koneksi internet anda terlebih dulu sebelum melanjutkan'
    }
  }
  switch (props.error?.statusCode) {
    case 404:
      return {
        title: 'Halaman Tidak Ditemukan',
        description:
          'Kami tidak bisa menemukan apa yang anda cari, pastikan url yang diakses sesuai ya!'
      }
    default:
      return {
        title: props.error?.statusMessage ?? 'Sedang Terjadi Kendala',
        description: props.error?.message
      }
  }
})

const back = () => {
  window.location.href = '/'
}
</script>
